<div class="subContWrap">
  <h2 class="b-tit">💗위시리스트💗</h2>
  <div class="">
    <div class="container">
      <div class="prodList">
        <!-- <products [products]="products" [config]="config" [urlWownet]="urlWownet"></products> -->
        <products2
          [products]="products"
          [config]="config"
          [urlWownet]="urlWownet"
        ></products2>
        <ng-container *ngIf="total > len">
          <div class="pagination row" [ngClass]="totalPage > 1 ? 'paging-normal' : ''">
            <paging [len]="len"
            [page]="page" 
            [config]="config" 
            [totalItems]="total"                
            (changePage)="handleOnChangePage($event)" 
            (totalPage)="handleOnTotalPage($event)"              
            [turnOnTotalPage]="true"               
            [turnOnPagination]="true" 
            [turnOnTotalItem]="true" 
            [isMobile]="false">
           </paging>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
